import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcEditFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.822 3.233c.684-.68 1.79-.68 2.473.002l1.526 1.527a1.75 1.75 0 0 1 0 2.475L8.027 20.03a.75.75 0 0 1-.418.211l-3.499.532a.75.75 0 0 1-.853-.853l.53-3.5.028-.118A.75.75 0 0 1 4 16.002zm1.411 1.064a.25.25 0 0 0-.352-.001l-2.268 2.256 1.886 1.885 2.261-2.26a.25.25 0 0 0 0-.354z",
    clipRule: "evenodd"
  }));
}
var IcEditFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcEditFill));

export { IcEditFill as I };
